<img src="/assets/404.svg" alt="404 Not Found" />

<button mat-flat-button *showIfPermitted="permission.ORDER_LIST" color="primary" (click)="router.navigate(['/orders'])">
  <mat-icon>arrow_back</mat-icon>
  Go back to Orders
</button>
